// @common
import Cookies from 'universal-cookie'
// @graphql
import client from 'graphql/Apollo/apolloClient'
import axios from 'axios'
import { ExternalRouteNames } from 'constants/routeNames'
import { FetchResult } from '@apollo/client'
import { LoginMutation } from '../../../lib/graphql/graphqlTypes'
import { Dispatch, SetStateAction } from 'react'

const cookies = new Cookies()

export const doLogout = async () => {
  const allCookies = cookies.getAll()
  Object.keys(allCookies).forEach((item) => cookies.remove(item))
  await client.clearStore()
  await axios.get(ExternalRouteNames.SSO_LOGOUT, { withCredentials: true })
  window.location.href = ExternalRouteNames.ATD_WEB_URL
}
type LoginInput = {
  variables: {
    input: {
      accessToken: string
    }
  }
}
type LoginResponse = FetchResult<LoginMutation>

type PropsType = {
  data: {
    username: string
    password: string
  }
  login: (loginInput: LoginInput) => Promise<LoginResponse>
  onLogin?: (() => void) | undefined
  onError?: () => void
  setIsLoginInProcess?: Dispatch<SetStateAction<boolean>> | undefined
}
export const doLogin = async ({
  data,
  login,
  onLogin,
  onError,
  setIsLoginInProcess,
}: PropsType) => {
  try {
    setIsLoginInProcess && setIsLoginInProcess(true)
    // getting access token
    const res = await axios.post(
      ExternalRouteNames.SSO_LOGIN,
      {
        username: data.username,
        password: data.password,
        pnid: process.env.REACT_APP_SSO_PARTNER_ID,
      },
      {
        withCredentials: true,
      },
    )
    // getting refreshToken and setting it to cookie as bsp.jwt
    const loginResponse = await login({
      variables: {
        input: {
          accessToken: res.data,
        },
      },
    })
    if (!loginResponse.data?.login) throw new Error()
    onLogin && onLogin()
    setIsLoginInProcess && setIsLoginInProcess(false)
    return loginResponse
  } catch (e) {
    setIsLoginInProcess && setIsLoginInProcess(false)
    onError && onError()
  }
}
